import { usePwaInstallPromptModal } from '../../lib/usePwaInstallPromptModal';
import { useTheme } from '../../lib/themeUtils';
import { useUserStore } from '../../lib/userStore';
import { useEmbedStore } from '../../lib/embedStore';
import toast from 'react-hot-toast';
import { isOnboardingDisabled } from '../../lib/onboarding';

export function PwaInstallModal({ language = 'fr' }: { language?: 'fr' | 'en' }) {
  const { showModal, handleInstall, deferredPrompt, dismiss } = usePwaInstallPromptModal();
  const { classes } = useTheme();
  const isBpmSession = useUserStore((s) => s.is_bpm_session);
  const userId = useUserStore((s) => s.user_id);
  const isEmbed = useEmbedStore((s) => s.isEmbed);

  // Ne pas interrompre l'onboarding BPM avec le modal PWA
  const bpmOnboardingActive =
    isBpmSession &&
    userId != null &&
    !!localStorage.getItem(`bpm-onboarding-v1-${userId}`);

  if (!showModal || bpmOnboardingActive || isEmbed || isOnboardingDisabled()) return null;

  // Détection iOS
  const isIOS = typeof window !== 'undefined' &&
    (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.userAgent.includes('Macintosh') && 'ontouchend' in document));

  // Détection Chrome/Android
  // const isAndroid = typeof window !== 'undefined' && /Android/.test(navigator.userAgent);

  // Message d'aide si pas d'événement
  const installHelp = isIOS
    ? (language === 'fr'
        ? "Sur iPhone, ouvre le menu 'Partager' puis choisis 'Ajouter à l'écran d'accueil'."
        : "On iPhone, open the 'Share' menu then choose 'Add to Home Screen'.")
    : (language === 'fr'
        ? "Si le bouton ne fonctionne pas, utilise le menu de ton navigateur pour installer l'application."
        : "If the button doesn't work, use your browser menu to install the app.");

  const handleInstallClick = () => {
    if (deferredPrompt) {
      handleInstall();
    } else {
      toast(language === 'fr'
        ? "L'installation n'est pas disponible sur ce navigateur. Utilise le menu de ton navigateur."
        : "Install is not available on this browser. Use your browser menu.", { icon: 'ℹ️' });
    }
  };

  return (
    <div className="modal fade show" role="dialog" aria-modal="true" tabIndex={-1} style={{ display: 'block', zIndex: 1060, backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered" role="document" style={{ pointerEvents: 'none' }}>
        <div className={classes.card} style={{ padding: 32, maxWidth: 480, margin: '0 auto', pointerEvents: 'auto' }}>
          <h5 className="mb-3 text-center">
            {language === 'fr'
              ? "Télécharge l'application Hockey Dynasty Pool sur ton mobile !"
              : "Download the Hockey Dynasty Pool app on your mobile!"}
          </h5>
          <p className="mb-4 text-center">
            {language === 'fr'
              ? "Ajoute l'application à ton écran d'accueil pour une expérience optimale."
              : "Add the app to your home screen for the best experience."}
          </p>
          <div className="d-flex justify-content-center gap-2 mb-3">
            <button
              className={classes.button.primary}
              onClick={handleInstallClick}
              disabled={!deferredPrompt}
              style={{ opacity: deferredPrompt ? 1 : 0.5, cursor: deferredPrompt ? 'pointer' : 'not-allowed' }}
            >
              {language === 'fr' ? 'Installer' : 'Install'}
            </button>
            <button className={classes.button.secondary} onClick={() => dismiss(24)}>
              {language === 'fr' ? 'Plus tard' : 'Later'}
            </button>
          </div>
          <div className="text-center text-muted" style={{ fontSize: '0.95rem' }}>
            {installHelp}
            {isIOS && (
              <div className="mt-3">
                <img src="https://developer.apple.com/design/human-interface-guidelines/images/intro/intro-install-pwa_2x.png" alt="Guide iOS" style={{ maxWidth: 220, borderRadius: 12 }} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
